module.exports = __webpack_public_path__ + "img/logo_shine_research_couleur_noir.588ff5e7.png";